// extracted by mini-css-extract-plugin
export default {"container":"StoresFilters_container__Ix0YC","filters":"StoresFilters_filters__9kNJR","wizard":"StoresFilters_wizard__UyUNd","table":"StoresFilters_table__GbHMZ"};